import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-payment-result24',
	templateUrl: './payment-result.component.html',
	styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent24 implements OnInit {

	constructor() {}

	ngOnInit(): void {}

}
